module.exports = "table {\n  font-size: 12px; }\n\n.table thead th {\n  padding: 0.55rem; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/pages/masive-members-load/masive-members-load.component.scss
// module id = ./src/app/admin/pages/masive-members-load/masive-members-load.component.scss
// module chunks = main